import { render, staticRenderFns } from "./StaffSurveyCreateEditModal.vue?vue&type=template&id=17fa845c"
import script from "./StaffSurveyCreateEditModal.vue?vue&type=script&lang=js"
export * from "./StaffSurveyCreateEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports